const InputBuilder = require ('./input-builder')
const StudentPreferences = require('common/models/student-preferences')

// course - getSelectedCourse
// startYear - getSelectedPrefs
// validLocations - StudentPreferences.getCourseLocations(course, selectedPreferences.studentType, selectedPreferences.placeOfResidence)
// teachingPeriods - getTeachingPeriods
// defaultTeachingScheduled - StudentPreferences.getDefaultTeachingScheduled(selectedPreferences.teachingPeriod, selectedPreferences.summerWinter)


class MissingOfferingsValidator {

      static offeringsExistTest(course, item, selectedPreferences, teachingPeriods){

         const validLocations = StudentPreferences.getCourseLocations(course, selectedPreferences.studentType, selectedPreferences.placeOfResidence)
         const defaultTeachingScheduled = StudentPreferences.getDefaultTeachingScheduled(selectedPreferences.teachingPeriod, selectedPreferences.summerWinter)

         const unit = InputBuilder.convertUnit(item, selectedPreferences.startYear, validLocations, teachingPeriods, defaultTeachingScheduled)

         return (unit.offerings?.length > 0 || unit.defaultOfferings?.length > 0)
      }
}

module.exports = MissingOfferingsValidator
